import HomeIcon from '@mui/icons-material/Home'
import { Breadcrumbs, Link, Typography } from '@mui/material'

export interface LinkPath {
  href: string
  label: string
}

export interface GlobalBreadcrumbsProps {
  current?: string
  path?: LinkPath[]
}

const GlobalBreadcrumbs = ({ current, path }: GlobalBreadcrumbsProps) => {
  return (
    <Breadcrumbs>
      <Link
        underline="hover"
        color="primary"
        href="/"
        sx={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', mt: 0.5 }}
      >
        <HomeIcon />
      </Link>
      {path?.map((p) => (
        <Link key={p.href} underline="hover" color="primary" href={p.href}>
          {p.label}
        </Link>
      ))}
      {current && (
        <Typography
          noWrap
          sx={{ color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 300 }}
        >
          {current}
        </Typography>
      )}
    </Breadcrumbs>
  )
}

export default GlobalBreadcrumbs
